import VIDABOO_CONSTANTS from '../config/consts';
let service = {};

service.db = {};
service.initialized = false;
service.openRequest = null;
service.getDataRequest = null;
service.addDataRequest = null;
service.removeDataRequest = null;

service.OnUpgrade = () => {
  //triggers if the client had no database
  // console.debug('upgradeneeded');
  service.db = service.openRequest.result;
  if (!service.db.objectStoreNames.contains(VIDABOO_CONSTANTS.INDEX_DB.STORE)) {
    //   // if there's no "threeDFiles" store
    //To store something in IndexedDB, we need an object store.

    const objectStore = service.db.createObjectStore(
      VIDABOO_CONSTANTS.INDEX_DB.STORE,
      {
        keyPath: 'fileId',
      },
    );
    objectStore.createIndex('blob', 'blob', {unique: false});

    objectStore.createIndex('fileId', 'fileId', {unique: true});
  }
};

service.initialize = (callback) => {
  const dbName = VIDABOO_CONSTANTS.INDEX_DB.NAME;
  // console.debug('initializeDbinitializeDb', service.db);
  // OPEN DATABASE
  service.openRequest = indexedDB.open(dbName, 1);
  service.openRequest.addEventListener('upgradeneeded', service.OnUpgrade);
  service.openRequest.addEventListener('error', (/* event */) => {
    callback(true);
    // console.debug("Why didn't you allow my web app to use IndexedDB?!", event);
  });
  service.openRequest.addEventListener('success', (event) => {
    // console.debug('DbComponent success: ', new Date());
    service.db = event.target.result;
    callback(true);
    // console.debug("Why didn't you allow my web app to use IndexedDB?!");
  });
};

service.isIndexDbSupported = () => {
  return !!(service.db && service.db.name);
};
service.addData = (fileId, blob, callback) => {
  const data = {
    fileId,
    blob,
  };
  if (service.isIndexDbSupported()) {
    const transaction = service.db.transaction(
      [VIDABOO_CONSTANTS.INDEX_DB.STORE],
      'readwrite',
    );

    const objectStore = transaction.objectStore(
      VIDABOO_CONSTANTS.INDEX_DB.STORE,
    );
    service.addDataRequest = objectStore.add(data);
    service.addDataRequest.addEventListener('success', () => {
      // console.debug('addDatasuccess');
      callback(true);
    });
    service.addDataRequest.addEventListener('error', (/* event */) => {
      // console.debug('addDataonerror', event);
      callback(false);
    });
  } else {
    callback(false);
  }
};

service.removeData = async (fileId, callback) => {
  if (service.isIndexDbSupported()) {
    const removeDataRequest = service.db
      .transaction([VIDABOO_CONSTANTS.INDEX_DB.STORE], 'readwrite')
      .objectStore(VIDABOO_CONSTANTS.INDEX_DB.STORE)
      .delete(fileId);
    removeDataRequest.addEventListener('success', () => {
      callback(true);
      // console.debug('successremoveDataRequest');
    });
    removeDataRequest.addEventListener('error', () => {
      callback(false);
      // console.debug('errorremoveDataRequest');
    });
  }
};

service.getRequestSuccess = (event, blob, callback) => {
  if (event && event.target.result) {
    blob = event.target.result.blob;
    callback(blob);
    return;
  } else {
    callback(null);
    return;
  }
};

service.getData = async (fileId, callback) => {
  let blob = '';
  console.debug('getData', service.isIndexDbSupported());
  if (service.isIndexDbSupported()) {
    const transaction = await service.db.transaction([
      VIDABOO_CONSTANTS.INDEX_DB.STORE,
    ]);
    const objectStore = await transaction.objectStore(
      VIDABOO_CONSTANTS.INDEX_DB.STORE,
    );
    service.getDataRequest = await objectStore.get(fileId);
    // console.debug('getDataRequestRef', service.getDataRequest);
    service.getDataRequest.addEventListener('error', () => {
      callback(null);
    });
    service.getDataRequest.addEventListener('success', (event) => {
      service.getRequestSuccess(event, blob, callback);
    });
  } else {
    callback(null);
  }
};

service.removeListeners = () => {
  if (service.openRequest) {
    service.openRequest.removeEventListener('error', () => {});
    service.openRequest.removeEventListener(
      'success',
      service.isIndexDbSupported,
    );
    service.openRequest.removeEventListener('upgradeneeded', service.OnUpgrade);
  }
  if (service.getDataRequest) {
    service.getDataRequest.removeEventListener(
      'success',
      service.getRequestSuccess,
    );
    service.getDataRequest.removeEventListener('error', () => {});
  }

  if (service.addDataRequest) {
    service.addDataRequest.removeEventListener('success', () => {});
    service.addDataRequest.removeEventListener('error', () => {});
  }
  if (service.removeDataRequest) {
    service.removeDataRequest.removeEventListener('success', () => {});
    service.removeDataRequest.removeEventListener('error', () => {});
  }
};

const indexDbService = {...service};
export default indexDbService;
